import {request} from "../../utils/apiUtils";
import {URL_API} from "../../url.config";

let ParentsController = {
    search: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/parent/search`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    removeLinkStudent: (parentId, studentId, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/parent/remove-link-student?parentId=${parentId}&studentId=${studentId}`,
            method: 'GET',
        }, callback)
    },
    delete: (campaignId, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/campaign/delete/${campaignId}`,
            method: 'GET',
        }, callback)
    }
}

export default ParentsController
